export const iluminacaoConfig = [
  { id: "grupo01",
    modulo: "1",
    idx: "1",
    descricao: "Porte-Cochère",
    lightType: "mixed",
    normalLights: [
      { x: 53, y: 30.5, width: 2.5, height: 5, circleNumber: 1 },
      { x: 42, y: 32.5, width: 2.5, height: 5, circleNumber: 1 },
      { x: 68, y: 26, width: 2.5, height: 5, circleNumber: 1 }
    ],
    ledStrips:[
      {x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 40.54 38.06 L 48.76 36.12", ledColor: "#00b8ff", ledMode: "static"},
      {x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 55.53 27.16 L 60.19 26.27", ledColor: "#00b8ff", ledMode: "static"},
      {x: 0, y: 0, width: 100, height: 100, isLedStrip: true, ledPath: "M 55.90 33.88 L 60.63 32.54", ledColor: "#00b8ff", ledMode: "static"},
    ]
  },
  { id: "grupo02", modulo: "1", idx: "2", descricao: "Circuito 02", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 2 },
  ]},
  { id: "grupo03", modulo: "1", idx: "3", descricao: "Floreira Piscina", lightType: "normal", multipleInstances:[
    {x: 10.5, y: 43, width: 2.5, height: 5, circleNumber: 3},
    {x: 14.5, y: 21, width: 2.5, height: 5, circleNumber: 3},
    {x: 24, y: 22, width: 2.5, height: 5, circleNumber: 3},
  ]},
  {
    id: "grupo04",
    modulo: "1",
    idx: "4",
    descricao: "Pet Place",
    lightType: "normal",
    multipleInstances: [
      { x: 13, y: 95, width: 2.5, height: 5, circleNumber: 4 },
      { x: 24, y: 95, width: 2.5, height: 5, circleNumber: 4 }
    ]
  },

  {
    id: "grupo05",
    modulo: "2",
    idx: "1",
    descricao: "Piscina",
    lightType: "normal",
    multipleInstances: [
      { x: 19.5, y: 30, width: 2.5, height: 5, circleNumber: 5 },
      { x: 27.5, y: 32, width: 2.5, height: 5, circleNumber: 5 }
    ]
  },
  { id: "grupo06",
    modulo: "2",
    idx: "2",
    descricao: "Postes",
    lightType: "normal",
    multipleInstances: [
      { x: 96, y: 21.5, width: 2.5, height: 5, circleNumber: 6 },
      { x: 89, y: 21, width: 2.5, height: 5, circleNumber: 6 },
      { x: 73.5, y: 20, width: 2.5, height: 5, circleNumber: 6 },
      { x: 59.5, y: 18, width: 2.5, height: 5, circleNumber: 6 },
      { x: 44.5, y: 17, width: 2.5, height: 5, circleNumber: 6 },
      { x: 34.5, y: 16, width: 2.5, height: 5, circleNumber: 6 },
      { x: 22.5, y: 15, width: 2.5, height: 5, circleNumber: 6 },
      { x: 12, y: 17, width: 2.5, height: 5, circleNumber: 6 },
      { x: 9, y: 25.5, width: 2.5, height: 5, circleNumber: 6 },
      { x: 7, y: 45.5, width: 2.5, height: 5, circleNumber: 6 },
      { x: 6, y: 60, width: 2.5, height: 5, circleNumber: 6 },
      { x: 4, y: 83, width: 2.5, height: 5, circleNumber: 6 }
    ]
  },
  { id: "grupo07", modulo: "2", idx: "3", descricao: "Circuito 07", lightType: "normal",  multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 7 }
  ]},
  { id: "grupo08", modulo: "2", idx: "4", descricao: "Circuito 08", lightType: "normal",  multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 8 },
  ]},

  { id: "grupo09", modulo: "3", idx: "1", descricao: "Circuito 09",lightType: "normal",  multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 9 },
  ]},
  { id: "grupo10", modulo: "3", idx: "2", descricao: "Circuito 10", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 10 }
  ]},
  { id: "grupo11", modulo: "3", idx: "3", descricao: "Vigia Sunset", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 11 },
  ]},
  { id: "grupo12", modulo: "3", idx: "4", descricao: "Vigia Sunshine", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 0, height: 0, circleNumber: 12 }
  ]},

  { id: "grupo13", modulo: "4", idx: "1", descricao: "Circuito 13", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 13 },
  ]},
  { id: "grupo14", modulo: "4", idx: "2", descricao: "Circuito 14", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 14 },
  ]},
  { id: "grupo15", modulo: "4", idx: "3", descricao: "Circuito 15", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 15 },
  ]},
  { id: "grupo16", modulo: "4", idx: "4", descricao: "Circuito 16", lightType: "normal", multipleInstances:[
    {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 16 },
  ]},
  
  {
    id: "grupo17",
    modulo: "5",
    idx: "1",
    descricao: "Pendente Piscina 1",
    lightType: "normal",
    multipleInstances: [
      { x: 40, y: 39, width: 2.5, height: 5, circleNumber: 17 }
    ]
  },
  {
    id: "grupo18",
    modulo: "5",
    idx: "2",
    descricao: "G - Hall Elevador Sunset",
    lightType: "normal",
    multipleInstances: [
      { x: 42, y: 54, width: 2.5, height: 5, circleNumber: 18 }
    ]
  },
  {
    id: "grupo19",
    modulo: "5",
    idx: "3",
    descricao: "Circuito 19",
    lightType: "normal",
    multipleInstances: [
      { x: 27, y: 63, width: 2.5, height: 5, circleNumber: 19 }
    ]
  },
  { id: "grupo20", modulo: "5", idx: "4", descricao: "Hall Elevador Sunset", lightType: "normal", multipleInstances:[
    { x: 32, y: 60, width: 2.5, height: 5, circleNumber: 20 },
  ]},

  { id: "grupo21", modulo: "6", idx: "1", descricao: "Corredor Hall Sunset", lightType: "normal", multipleInstances:[
    { x: 39, y: 55, width: 2.5, height: 5, circleNumber: 21 },

  ]},
  {
    id: "grupo22",
    modulo: "6",
    idx: "2",
    descricao: "Circuito 22",
    lightType: "normal",
    multipleInstances: [
      { x: 51, y: 53.5, width: 2.5, height: 5, circleNumber: 22 }
    ]
  },
  {
    id: "grupo23",
    modulo: "6",
    idx: "3",
    descricao: "Circuito 23",
    lightType: "normal",
    multipleInstances: [
      { x: 56, y: 51.5, width: 2.5, height: 5, circleNumber: 23 }
    ]
  },
  {
    id: "grupo24",
    modulo: "6",
    idx: "4",
    descricao: "Circuito 24",
    lightType: "normal",
    multipleInstances: [
      { x: 54.5, y: 39.5, width: 2.5, height: 5, circleNumber: 24 }
    ]
  },
  
  {
    id: "grupo25",
    modulo: "7",
    idx: "1",
    descricao: "Circuito 25",
    lightType: "normal",
    multipleInstances: [
      { x: 35.5, y: 52.5, width: 2.5, height: 5, circleNumber: 25 },
      { x: 30.5, y: 54, width: 2.5, height: 5, circleNumber: 25 }
    ]
  },
  {
    id: "grupo26",
    modulo: "7",
    idx: "2",
    descricao: "Circuito 26",
    lightType: "normal",
    multipleInstances: [
      { x: 47, y: 53, width: 2.5, height: 5, circleNumber: 26 }
    ]
  },
  { id: "grupo27", modulo: "7", idx: "3", descricao: "Led Piscina Coberta", lightType: "normal", multipleInstances:[
      {x: 19.5, y: 72, width: 2.5, height: 5, circleNumber: 27},
  ]},
  { id: "grupo28", modulo: "7", idx: "4", descricao: "Circuito 28", lightType: "normal", multipleInstances:[
      {x: 500, y: 0, width: 2.5, height: 5, circleNumber: 28},
  ]},
  
  { id: "grupo29", modulo: "8", idx: "1", descricao: "Pendente piscina 2", lightType: "normal", multipleInstances:[
    { x: 30, y: 47.5, width: 2.5, height: 5, circleNumber: 29 },

  ]},
  { id: "grupo30", modulo: "8", idx: "2", descricao: "Corredor Piscina", lightType: "normal", multipleInstances:[
    {x: 25, y: 57, width: 2.5, height: 5, circleNumber: 30},
  ]},
  { id: "grupo31", modulo: "8", idx: "3", descricao: "Lâmpadas Piscina Coberta", lightType: "normal",multipleInstances:[
      {x: 17.5, y: 54, width: 2.5, height: 5, circleNumber: 31},
  ]},
  { id: "grupo32", modulo: "8", idx: "4", descricao: "Circuito 32", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 32, lightType: "normal" },
  
  { id: "grupo33", modulo: "9", idx: "1", descricao: "Circuito 33", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 33, lightType: "normal" },
    {
    id: "grupo34",
    modulo: "9",
    idx: "2",
    descricao: "Circuito 34",
    lightType: "normal",
    multipleInstances: [
      { x: 73, y: 51, width: 2.5, height: 5, circleNumber: 34 }
    ]
  },
    {
    id: "grupo35",
    modulo: "9",
    idx: "3",
    descricao: "Circuito 35",
    lightType: "normal",
    multipleInstances: [
      { x: 68, y: 46, width: 2.5, height: 5, circleNumber: 35 }
    ]
  },
  {
    id: "grupo36",
    modulo: "9",
    idx: "4",
    descricao: "Circuito 36",
    lightType: "normal",
    multipleInstances: [
      { x: 69, y: 53.5, width: 2.5, height: 5, circleNumber: 36 }
    ]
  },
  
  {
    id: "grupo37",
    modulo: "10",
    idx: "1",
    descricao: "Circuito 37",
    lightType: "normal",
    multipleInstances: [
      { x: 76, y: 46, width: 2.5, height: 5, circleNumber: 37 }
    ]
  },
  { id: "grupo38", modulo: "10", idx: "2", descricao: "Circuito 38", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 38, lightType: "normal" },
  { id: "grupo39", modulo: "10", idx: "3", descricao: "Circuito 39", x: 500, y: 0, width: 2.5, height: 5, circleNumber: 39, lightType: "normal" },
  { id: "grupo40",
    modulo: "10",
    idx: "4",
    descricao: "Circuito 40",
    lightType: "normal",
    multipleInstances: [
      { x: 51.5, y: 58, width: 2.5, height: 5, circleNumber: 40 },
      { x: 38, y: 61, width: 2.5, height: 5, circleNumber: 40 },
      { x: 62, y: 56, width: 2.5, height: 5, circleNumber: 40 }
    ]
  },
  { id: "grupo41",
    modulo: "11",
    idx: "1",
    descricao: "Circuito 41",
    lightType: "normal",
    multipleInstances: [
      { x: 63, y: 44, width: 2.5, height: 5, circleNumber: 41 }
    ]
  },
  { id: "grupo42",
    modulo: "11",
    idx: "2",
    descricao: "Circuito 42",
    lightType: "normal",
    multipleInstances: [
      { x: 70.5, y: 49, width: 2.5, height: 5, circleNumber: 42 }
    ]
  },
  { id: "grupo43",
    modulo: "11",
    idx: "3",
    descricao: "Quadra Beach tenis",
    lightType: "normal",
    multipleInstances: [
      { x: 75, y: 78, width: 2.5, height: 5, circleNumber: 43 },
      { x: 86.5, y: 78, width: 2.5, height: 5, circleNumber: 43 },
      { x: 85.5, y: 95, width: 2.5, height: 5, circleNumber: 43 },
      { x: 75, y: 95.5, width: 2.5, height: 5, circleNumber: 43 }
    ]
  },
  { id: "grupo44",
    modulo: "11",
    idx: "4",
    descricao: "Quadra de Futsal",
    lightType: "normal",
    multipleInstances: [
      { x: 90, y: 70, width: 2.5, height: 5, circleNumber: 44 },
      { x: 98, y: 71, width: 2.5, height: 5, circleNumber: 44 },
      { x: 90, y: 88, width: 2.5, height: 5, circleNumber: 44 },
      { x: 97.5, y: 88, width: 2.5, height: 5, circleNumber: 44 }
    ]
  },
  { id: "grupo45",
    modulo: "12",
    idx: "1",
    descricao: "Circuito 45",
    lightType: "normal",
    multipleInstances: [
      { x: 49, y: 47.5, width: 2.5, height: 5, circleNumber: 45 }
    ]
  },
  { id: "grupo46",
    modulo: "12",
    idx: "2",
    descricao: "Quadra de Tenis",
    lightType: "normal",
    multipleInstances: [
      { x: 46, y: 95, width: 2.5, height: 5, circleNumber: 46 },
      { x: 58, y: 95, width: 2.5, height: 5, circleNumber: 46 },
      { x: 43, y: 68.5, width: 2.5, height: 5, circleNumber: 46 },
      { x: 48.5, y: 68, width: 2.5, height: 5, circleNumber: 46 },
      { x: 58, y: 68.5, width: 2.5, height: 5, circleNumber: 46 }
    ]
  },
  { id: "grupo47",
    modulo: "12",
    idx: "3",
    descricao: "Vestiarios Quadras",
    lightType: "normal",
    multipleInstances: [
      { x: 69.5, y: 70, width: 2.5, height: 5, circleNumber: 47 },
      { x: 89.5, y: 62.5, width: 2.5, height: 5, circleNumber: 47 },
      { x: 83, y: 75, width: 2.5, height: 5, circleNumber: 47 },
      { x: 81, y: 66, width: 2.5, height: 5, circleNumber: 47 }
    ]
  },
  { id: "grupo48",
    modulo: "12",
    idx: "4",
    descricao: "Floreira Quadra Tenis",
    lightType: "normal",
    multipleInstances: [
      { x: 53, y: 68, width: 2.5, height: 5, circleNumber: 48 },
      { x: 62, y: 68.5, width: 2.5, height: 5, circleNumber: 48 },
      { x: 92.5, y: 28.5, width: 2.5, height: 5, circleNumber: 48 },
      { x: 94, y: 42, width: 2.5, height: 5, circleNumber: 48 },
      { x: 97.5, y: 47, width: 2.5, height: 5, circleNumber: 48 },
      { x: 97.5, y: 57, width: 2.5, height: 5, circleNumber: 48 }
    ]
  },

  { id: "grupo49", modulo: "13", idx: "1", descricao: "Circuito 49", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 49 },
  ]},
  { id: "grupo50", modulo: "13", idx: "2", descricao: "Circuito 50", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 50 },
  ]},
  { id: "grupo51", modulo: "13", idx: "3", descricao: "Circuito 51", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 51 },
  ]},
  { id: "grupo52", modulo: "13", idx: "4", descricao: "Circuito 52", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 52 },
  ]},

  { id: "grupo53", modulo: "14", idx: "1", descricao: "Circuito 53", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 53 },
  ]},
  { id: "grupo54", modulo: "14", idx: "2", descricao: "Circuito 54", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 54 },
  ]},
  { id: "grupo55", modulo: "14", idx: "3", descricao: "Circuito 55", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 55 },
  ]},
  { id: "grupo56", modulo: "14", idx: "4", descricao: "Circuito 56", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 56 },
  ]},

  { id: "grupo57", modulo: "15", idx: "1", descricao: "Circuito 57", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 57 },
  ]},
  { id: "grupo58", modulo: "15", idx: "2", descricao: "Circuito 58", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 58 },
  ]},
  { id: "grupo59", modulo: "15", idx: "3", descricao: "Circuito 59", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 59 },
  ]},
  { id: "grupo60", modulo: "15", idx: "4", descricao: "Circuito 60", lightType: "normal", multipleInstances: [
    { x: 500, y: 0, width: 2.5, height: 5, circleNumber: 60 },
  ]},
];

// Função útil para obter informações de ON/OFF para cada circuito
export const getCircuitOnOffValues = (circuitNumber) => {
  const circuitIndex = circuitNumber - 1;
  if (circuitIndex < 0 || circuitIndex >= iluminacaoConfig.length) {
    return null;
  }
  
  const circuit = iluminacaoConfig[circuitIndex];
  return {
    descricao: circuit.descricao,
    onValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "ON" }),
    offValue: JSON.stringify({ modulo: circuit.modulo, idx: circuit.idx, status: "OFF" })
  };
};